<dashboard-loader *ngIf="isImportingTemplate$ | async" [title]="'Importing template...'"></dashboard-loader>
<div
  *ngIf="
    (templateImported$ | async) || ((isImportingTemplate$ | async) === false && (templateImported$ | async) === false)
  "
  class="cc-material-theme"
>
  <dashboard-dialog-title [title]="'Import template'"></dashboard-dialog-title>
  <mat-dialog-content fxLayout="column" fxLayoutAlign=" start" fxLayoutGap="20px">
    <div fxLayout="row">To import a template, select a JSON file with the template name and click import.</div>
    <div fxLayout="row" fxLayoutGap="20px">
      <input
        class="dashboard-import-template"
        #fileInput
        (change)="selectJSON($event)"
        onclick="this.value = null"
        type="file"
      />
      <button mat-raised-button color="accent" (click)="fileInput.click()">
        {{ SELECT_JSON_FILE_LABEL | uppercase }}
      </button>
      <button mat-raised-button color="accent" *ngIf="importFiles && importFiles.length" (click)="doImport()">
        {{ 'Import' | uppercase }}
      </button>
    </div>
  </mat-dialog-content>
</div>
